module.exports = __webpack_public_path__ + "media/images/flt-logo@2xt-63694719f11ddfe49be31a21621351b2.png";